/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TemplateAttribute } from './';
import {
    TemplateAttributeFromJSON,
    TemplateAttributeFromJSONTyped,
    TemplateAttributeToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalDetailsTemplate
 */
export interface LegalDetailsTemplate {
    /**
     * 
     * @type {string}
     * @memberof LegalDetailsTemplate
     */
    template: string;
    /**
     * 
     * @type {Array<TemplateAttribute>}
     * @memberof LegalDetailsTemplate
     */
    attributes: Array<TemplateAttribute>;
}

/**
 * Check if a given object implements the LegalDetailsTemplate interface.
 */
export function instanceOfLegalDetailsTemplate(value: object): value is LegalDetailsTemplate {
    if (!('template' in value) || value['template'] === undefined) return false;
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    return true;
}

export function LegalDetailsTemplateFromJSON(json: any): LegalDetailsTemplate {
    return LegalDetailsTemplateFromJSONTyped(json, false);
}

export function LegalDetailsTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalDetailsTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'template': json['template'],
        'attributes': ((json['attributes'] as Array<any>).map(TemplateAttributeFromJSON)),
    };
}

export function LegalDetailsTemplateToJSON(value?: LegalDetailsTemplate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'template': value['template'],
        'attributes': ((value['attributes'] as Array<any>).map((v) => TemplateAttributeToJSON(v))),
    };
}

